/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha <snigdha.dhanireddy@mroads.com>, August 2020
 * @format
 * @flow
 */

import { ActionTypes } from '../constants';

export function addAppLog(log: { logLevel: String, message: String }) {
  return {
    type: ActionTypes.SERVERAPP_ADD_LOG,
    payload: { log },
  };
}

export function clearAppLogs() {
  return {
    type: ActionTypes.SERVERAPP_CLEAR_LOGS,
    payload: {},
  };
}
